module.exports = __webpack_public_path__ + "static/media/logo_structured_data.a3c9d588.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo_structured_data.png
// module id = 1148
// module chunks = 2